import React, { FunctionComponent, ReactNode } from "react";
import { Link } from "wouter";

import { HashtagString } from "../stores/useHashState";

type HashLinkProps = {
  children: ReactNode;
  className?: string;
  hash: HashtagString;
};

export const HashLink: FunctionComponent<HashLinkProps> = ({
  children,
  className,
  hash,
}) => {
  return (
    <Link className={className} replace to={hash}>
      {children}
    </Link>
  );
};
